export default "__VITE_ASSET__tFTKQL8x__"